import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'antd';
import { modalViewAction } from '../../../appRedux/actions/Ui';
import {
  clearFiltersData,
  clearFormFilters,
  clearPaginationConfig,
  setFiltersData,
  setFormFilters,
  setPaginationConfig,
} from '../../../appRedux/actions/General';
import './styles.css';

export const ModalView = ({ title, width, children, open, onCancel }) => {
  const { modalView } = useSelector((state) => state.ui);
  const { filtersData, formFilters, paginationConfig } = useSelector(
    (state) => state.generalStates
  );
  const dispatch = useDispatch();
  const tableStateRef = useRef(null);
  const wasOpenRef = useRef(false);

  const isOpen = open ?? modalView;

  if (isOpen && !wasOpenRef.current && !tableStateRef.current) {
    tableStateRef.current = {
      filtersData: { ...filtersData },
      formFilters: { ...formFilters },
      paginationConfig: { ...paginationConfig },
    };
  }

  useEffect(() => {
    if (isOpen) {
      wasOpenRef.current = true;
      return;
    }

    if (!wasOpenRef.current || !tableStateRef.current) return;

    const tableState = tableStateRef.current;

    dispatch(clearFiltersData());
    dispatch(setFiltersData(tableState.filtersData));
    dispatch(clearFormFilters());
    dispatch(setFormFilters(tableState.formFilters));
    dispatch(clearPaginationConfig());
    dispatch(setPaginationConfig(tableState.paginationConfig));

    tableStateRef.current = null;
    wasOpenRef.current = false;
  }, [dispatch, isOpen]);

  const handleCancel = onCancel ?? (() => dispatch(modalViewAction(false)));

  return (
    <Modal
      title={<h2>{title}</h2>}
      open={isOpen}
      destroyOnClose
      onCancel={handleCancel}
      width={width ?? 'auto'}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ style: { display: 'none' } }}
      style={{ maxWidth: '1400px' }}
    >
      {children}
    </Modal>
  );
};
